var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00757 6.25788C6.00757 5.86182 6.12501 5.47465 6.34505 5.14534C6.56509 4.81603 6.87784 4.55937 7.24375 4.4078C7.60966 4.25624 8.01229 4.21658 8.40074 4.29385C8.78919 4.37112 9.146 4.56184 9.42605 4.84189C9.70611 5.12195 9.89683 5.47876 9.9741 5.86721C10.0514 6.25565 10.0117 6.65829 9.86014 7.0242C9.70858 7.39011 9.45191 7.70286 9.1226 7.9229C8.79329 8.14293 8.40613 8.26038 8.01007 8.26038V9.51194",
    stroke: "#8490A0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 12.6258C8.47555 12.6258 8.86107 12.2403 8.86107 11.7648C8.86107 11.2892 8.47555 10.9037 7.99999 10.9037C7.52443 10.9037 7.13892 11.2892 7.13892 11.7648C7.13892 12.2403 7.52443 12.6258 7.99999 12.6258Z",
    fill: "#8490A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.2491C12.0036 15.2491 15.2491 12.0036 15.2491 8.00004C15.2491 3.99649 12.0036 0.750977 8.00004 0.750977C3.99649 0.750977 0.750977 3.99649 0.750977 8.00004C0.750977 12.0036 3.99649 15.2491 8.00004 15.2491Z",
    stroke: "#8490A0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.314413b8.svg";
export { ForwardRef as ReactComponent };